import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { InputModule } from '../input/input.module';
import { ReactiveFormsModule } from '@angular/forms';

import { RangeDatepickerComponent } from './components/range-datepicker/range-datepicker.component';

@NgModule({
  declarations: [RangeDatepickerComponent],
  imports: [
    CommonModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatInputModule,
    MatFormFieldModule,
    InputModule,
    ReactiveFormsModule
  ],
  exports: [RangeDatepickerComponent]
})
export class RangeDatepickerModule {}
